import React from 'react'
import TimeTableHeaderItem from './TimeTableHeaderItem';
import TimeTableItem from './TimeTableItem';

const TimeTableColumn = ({ model }) => {
    return (
        <div className="" style={{ width: "10rem", display: "flex", flexDirection: "column", margin: "0 0.25rem", backgroundColor: "#fff" }}>
            <TimeTableHeaderItem />
            <TimeTableItem />
            <TimeTableItem />
            <TimeTableItem />
            <TimeTableItem />
            <TimeTableItem />

        </div>
    );
}

export default TimeTableColumn;